/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    card: {
      maxWidth: theme.spacing(55.9),
      width: "100%",
      minWidth: theme.spacing(16),
      height: 266,
      border: "1px solid rgba(0, 0, 0, 0.05)",
      borderRadius: 6,
      boxShadow: "inherit",
      background: "#FBFBFB",
    },
    cardHoverBoxShadow: {
      "&:hover": {
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      },
    },
    link: {
      textDecoration: "inherit",
      color: "inherit",
      display: "block",
      width: "100%",
      height: "100%",
    },
    content: {
      background: "#004A96",
      display: "flex",
      padding: 0,
      width: "100%",
      height: "100%",
      borderRadius: 6,
      "&:last-child": {
        padding: 0,
      },
    },
    title: {
      fontSize: "22px",
      lineHeight: "30px",
      fontWeight: "bold",
      color: "#333333",
    },
    fontDescrition: {
      fontSize: "14px",
      lineHeight: "20px",
      color: "#333333",
      paddingTop: 8,
      opacity: 0.8,
    },
    disabledBlock: {
      textDecoration: "inherit",
      color: "inherit",
      display: "block",
      width: "100%",
      height: "100%",
    },
    disabledContent: {
      background: "#bfbfbf",
      opacity: 0.3,
    },
    blockImg: {
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: 128,
      backgroundSize: "cover",
      display: "flex",
      mixBlendMode: "luminosity",
    },
    imgRoot: {
      width: "100%",
      height: 128,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    },
    svg: {
      zIndex: 1,
      position: "absolute",
      width: "100%",
      height: 128,
      top: 0,
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      "& svg": {
        width: 72,
        height: 72,
      },
    },
    contentRoot: {
      width: "100%",
      height: "inherit",
      position: "relative",
    },
    description: {
      background: "#FBFBFB",
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      height: 138,
      padding: 20,
    },
    gradient: {
      width: "100%",
      height: 128,
      position: "absolute",
      top: 0,
      left: 0,
    },
  });

export const useStyles = makeStyles(styles);
